<script>
	import { page } from '$app/state';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import indowPro from './images/Indow-PRO-LP-Headers-992x398-E2-03-31-26.jpg';
	import bg1 from './images/page-title-headers-01.jpg';
	import bg2 from './images/page-title-headers-02.jpg';
	import bg3 from './images/page-title-headers-03.jpg';
	import bg4 from './images/page-title-headers-04.jpg';

	let backgroundImages = new Map([
		['solutions', bg1],
		['commercial', bg2],
		['resources', bg3],
		['about-indow', bg4],
	]);
</script>

{#if page?.data?.showTitle}
	<Section
		backgroundColor={page.data?.indowPro ? 'grey-light-medium' : 'blue'}
		class="flex-none!"
		innerClass={[
			'pt-[clamp(3rem,5vw,6rem)] md:pt-[clamp(2.5rem,5vw,6rem)] pb-[clamp(2.5rem,5vw,6rem)]',
		].join(' ')}
		backgroundImage={(page.data?.backgroundImage ?? page.data?.indowPro)
			? indowPro
			: (backgroundImages.get(page?.url?.pathname?.split('/')?.[1]) ?? null)}
		loading="eager"
	>
		<h1
			class={['font-bold', { 'text-indow-yellow-light': page.data?.indowPro }]}
		>
			{page?.data?.h1 ??
				page?.data?.title ??
				page?.url?.pathname?.split('/')?.filter(Boolean)?.slice(-1)}
		</h1>
	</Section>
{/if}
